<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <date-field
          :label="'报销日期'"
          v-model="jsonData.fa_date"
        />
        <fee-receiver-field
          :label="'收款名称'"
          v-model="jsonData.fp_receiver"
          @select="onSelectReceiver"
        />
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              "开户银行"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="jsonData.fp_bank"
              placeholder="选择收款名称后自动填写"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              "银行账号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="jsonData.fp_bankaccount"
              placeholder="选择收款名称后自动填写"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import DateField from "@/components/field/DateField.vue";
import FeeReceiverField from "@/components/field/FeeReceiverField.vue";

export default {
  components: {
    DateField,
    FeeReceiverField
  },
  data() {
    const date = this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss")

    return {
      jsonData: {
        id: null,
        fa_date: date,
        fp_receiver: "",
        fp_bank: "",
        fp_bankaccount: ""
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.jsonData.id = to.params.id || to.query.id;
    });
  },
  methods: {
    save() {
      var me = this,
        jsonData = me.jsonData

      if (!jsonData.fa_date) {
        me.$weui.topTips("请填写报销日期", 2000);
      } else if (!jsonData.fp_receiver) {
        me.$weui.topTips("请填写收款名称", 2000);
      } else if (!jsonData.fp_bank) {
        me.$weui.topTips("请填写开户银行", 2000);
      } else if (!jsonData.fp_bankaccount) {
        me.$weui.topTips("请填写银行账号", 2000);
      } else {
        me.p_save()
      }
    },
    p_save() {
      let me = this

      me.$ajax({
        url: "/api/oa/feeapply/turnFeePlease",
        method: "POST",
        jsonData: me.jsonData
      }).then(function (res) {
        if (res.data) {
          me.$weui.toast("转报销成功", 2000);
          me.$router.replace('/oa/fee/' + res.data.id);
        }
      });
    },
    onSelectReceiver(selected) {
      const jsonData = this.jsonData

      jsonData.fp_bank = selected.re_bank
      jsonData.fp_bankaccount = selected.re_bankaccount
    }
  },
};
</script>